import { useSelector } from 'react-redux';
import { contextToPageNameMap } from 'constants/context';
import commonStrings from 'modules/common/strings';
import logo from 'assets/images/logo.svg';
import SectionDivider from 'modules/common/components/SectionDivider';
import { azureAuthentication } from 'utils/functions/authentication';
import {
  Wrapper,
  LogoWrapper,
  Logo,
  ItemContainer,
  ItemLink,
  ItemWrapper,
  Item,
  LogoutBtn,
} from './Sidebar.style';
// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
const { logoutPopup } = azureAuthentication();
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const Sidebar = () => {
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const context = useSelector(state => state.common.context);

  const sidebarItems = [
    {
      contexts: ['services'],
      name: contextToPageNameMap.services,
      icon: '"\\e901"',
    },
    {
      contexts: ['masterServices'],
      name: contextToPageNameMap.masterServices,
      icon: '"\\e900"',
    },
  ];
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <Wrapper>
      <div>
        <LogoWrapper>
          <Logo src={logo} alt={commonStrings.sidebar.logoImageAltText} />
        </LogoWrapper>
        {sidebarItems.map(sidebarItem => {
          const isItemSelected = sidebarItem.contexts.includes(context);
          return (
            <ItemContainer key={sidebarItem.contexts[0]} pushToEnd={sidebarItem.pushToEnd}>
              <ItemLink to={`/${sidebarItem.contexts[0]}`}>
                <ItemWrapper icon={sidebarItem.icon} selected={isItemSelected}>
                  {sidebarItem.name && (
                    <>
                      <SectionDivider gap={6} />
                      <Item selected={isItemSelected}>{sidebarItem.name}</Item>
                    </>
                  )}
                </ItemWrapper>
              </ItemLink>
            </ItemContainer>
          );
        })}
      </div>
      <LogoutBtn
        onClick={() => {
          logoutPopup().then(() => {
            document.location.href = '/login';
          });
        }}
      >
        Logout
      </LogoutBtn>
    </Wrapper>
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

Sidebar.propTypes = {};

Sidebar.defaultProps = {};

export default Sidebar;
